import React from "react";
import { View } from "react-native";
import { ComponentsFactory } from "../../ComponentsFactory";

export default function MorePageLink(props, controller) {
  const { testing_preferences } = controller.state?.settings || {};
  const uiVersion = "v3";
  const PageMoreTag = ComponentsFactory("PageMore", uiVersion);

  return (
    <View>
      <PageMoreTag title="More" controller={controller} />
    </View>
  );
}
